import { parseISO } from 'date-fns';
import subMinutes from 'date-fns/subMinutes';

import { usePopup, useUser } from '@shared/hooks';

import { consultationStatus, useConsultation } from '@src/entities/consultations';

export const useConnect = (consultationId: number) => {
	const { consultation } = useConsultation(consultationId);
	const { user } = useUser();
	const { popup } = usePopup();

	const status = consultationStatus(consultation);

	const canStart = consultation
		? subMinutes(parseISO(consultation.start_time), 15) < new Date()
		: false;

	const isFinished = consultation ? parseISO(consultation.end_time) < new Date() : false;

	const isConnectActive = status === 'confirmed' && canStart && !isFinished;

	const onConnect = () => {
		if (!isConnectActive || !consultation?.meeting)
			return popup({ type: 'error', text: 'Встреча не создана' });

		if (!canStart) return popup({ type: 'error', text: 'Консультация еще не началась' });

		if (isFinished) return popup({ type: 'error', text: 'Консультация уже завершилась' });

		if (user?.is_coach) window.open(consultation.meeting.start_url, '_blank', 'noreferrer');

		if (user?.is_client) window.open(consultation.meeting.join_url, '_blank', 'noreferrer');
	};

	return {
		isConnectActive,
		onConnect,
	};
};
